import { defineComponent } from '~/scripts/utils/alpine'

/**
 * LoadMorePosts component
 * Handles the "View more" button on blog list.
 * Expects:
 * <div x-data="LoadMorePosts" x-ref="gridWrapper">
 *   <div x-ref="grid" class="grid ...">...</div>
 *   <button data-url="…" @click.prevent="loadMore($el)">…</button>
 * </div>
 */
export default defineComponent(() => ({
  async loadMore(button: HTMLButtonElement) {
    const url = button.dataset.url
    if (!url) return
    button.disabled = true
    try {
      const response = await fetch(url)
      if (!response.ok) throw new Error(response.statusText)
      const json = await response.json()
      const wrapper = document.createElement('div')
      wrapper.innerHTML = json.data

      // Append new cards
      const newGrid = wrapper.querySelector('div.grid') as HTMLDivElement | null
      if (newGrid) {
        this.$refs.grid.insertAdjacentHTML('beforeend', newGrid.innerHTML)
      }

      // Replace or remove the button
      const nextButton = wrapper.querySelector(
        'button[data-url]',
      ) as HTMLButtonElement | null
      if (nextButton) {
        button.replaceWith(nextButton)
      } else {
        button.remove()
      }
    } catch {
      button.disabled = false
    }
  },
}))
